<table>
  <thead>
      <tr>
          <th class="subtable string">{{'mantenimiento-entidades-control.royalties.moneda' | translate}}</th>
          <th class="subtable string">{{'mantenimiento-entidades-control.royalties.superficie' | translate}}</th>
          <th class="subtable string">{{'mantenimiento-entidades-control.royalties.plantas' | translate}}</th>
          <th class="subtable string">{{'mantenimiento-entidades-control.royalties.peso' | translate}}</th>
          <th class="subtable action"></th>
      </tr>
  </thead>
  <tbody>
      <tr [formGroup]="newEditForm">
        <td class="short" [ngClass]="{'show-error':showError}">
          <app-filterable-list [itemsList]="unidadesDivisas" [selectedItem]="newEditForm.get('divisas')" [disabled]="disabledDivisas" [placeHolder]="false">
          </app-filterable-list>
        </td>
        <td class="short" [ngClass]="{'show-error':showError}">
          <app-filterable-list [itemsList]="unidadesSuperficie" [selectedItem]="newEditForm.get('superficie')" [disabled]="disabledSuperficie" [placeHolder]="false">
          </app-filterable-list>
        </td>
        <td class="short" [ngClass]="{'show-error':showError}">
          <app-filterable-list [itemsList]="unidadesNPlantas" [selectedItem]="newEditForm.get('plantas')" [disabled]="disabledNPlantas" [placeHolder]="false">
          </app-filterable-list>
        </td>
        <td class="short" [ngClass]="{'show-error':showError}">
          <app-filterable-list [itemsList]="unidadesPeso" [selectedItem]="newEditForm.get('peso')" [disabled]="disabledPeso" [placeHolder]="false">
          </app-filterable-list>
        </td>
        <td class="multi-actions">
          <ng-container *ngIf="onEdit">
            <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
          </ng-container>
          <ng-container *ngIf="!onEdit">
            <i class="fas fa-pencil-alt" title="{{'titles.editar' | translate}}" (click)="enableFilters()"></i>
          </ng-container>
        </td>
      </tr>
  </tbody>
</table>